import React, { Component } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router';
import util from '@util/index';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  columns = () => {
    return [
      {
        title: '客户',
        dataIndex: 'customName',
        key: 'customName',
        width: 150,
        render: (text, record) => (
          <Link to={`/incubator/${this.props.params.uuid}/custom/detail/${record.customUuid}`}>
            {text}
          </Link>
        ),
      },
      {
        title: '收款公司',
        dataIndex: 'companyName',
        key: 'companyName',
        width: 150,
      },
      {
        title: '可开发票金额',
        dataIndex: 'availableInvoice',
        key: 'availableInvoice',
        render: text => <span>{util.numberFormat(text)}</span>,
      },
      {
        title: '可开收据金额',
        dataIndex: 'availableReceipt',
        key: 'availableReceipt',
        render: text => <span>{util.numberFormat(text)}</span>,
      },
      {
        title: '已开发票金额（含在开）',
        dataIndex: 'amountInvoice',
        key: 'amountInvoice',
        render: text => <span>{util.numberFormat(text)}</span>,
      },
      {
        title: '已开收据金额（含在开）',
        dataIndex: 'amountReceipt',
        key: 'amountReceipt',
        render: text => <span>{util.numberFormat(text)}</span>,
      },
      {
        title: '操作',
        dataIndex: 'invalid',
        width: 90,
        render: (text, record) => (
          <Link
            to={`/incubator/one/${this.props.params.uuid}/invoice/${record.customUuid}/byCustom`}
          >
            开票列表
          </Link>
        ),
      },
    ];
  };

  render() {
    const { list, pagination, loading } = this.props;
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        rowKey="uuid"
        onChange={this.props.handleTableChange}
        loading={loading}
      />
    );
  }
}

export default Manage;



// WEBPACK FOOTER //
// ./src/components/incubator/invoice/TableCustomStatic.js